export default "__VITE_ASSET__D$TJsOqR__"